export const MRN_STATE = {
  OK: "MrnOk",
  BLANK: "MrnBlank",
  BLOCKED: "MrnBlocked",
  DUP: "MrnDup",
  CHANGED: "MrnChanged",
  FIXED: "MrnFixed",
};
